var _objectSpread = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectSpread2").default;
var _objectWithoutProperties = require("D:/workspace/uat/platform-uat/Platform-foundation-pc/node_modules/@babel/runtime/helpers/objectWithoutProperties").default;
var _excluded = ["class", "staticClass", "style", "staticStyle", "attrs"];
require("core-js/modules/es.array.concat.js");
module.exports = {
  functional: true,
  render: function render(_h, _vm) {
    var _c = _vm._c,
      _v = _vm._v,
      data = _vm.data,
      _vm$children = _vm.children,
      children = _vm$children === void 0 ? [] : _vm$children;
    var classNames = data.class,
      staticClass = data.staticClass,
      style = data.style,
      staticStyle = data.staticStyle,
      _data$attrs = data.attrs,
      attrs = _data$attrs === void 0 ? {} : _data$attrs,
      rest = _objectWithoutProperties(data, _excluded);
    return _c('svg', _objectSpread({
      class: [classNames, staticClass],
      style: [style, staticStyle],
      attrs: Object.assign({
        "width": "25",
        "height": "24",
        "xmlns": "http://www.w3.org/2000/svg"
      }, attrs)
    }, rest), children.concat([_c('g', {
      attrs: {
        "fill": "none",
        "fill-rule": "evenodd"
      }
    }, [_c('path', {
      attrs: {
        "d": "M.078 0h24.32v24H.078z"
      }
    }), _c('g', {
      attrs: {
        "fill": "var(--mainColor)",
        "fill-rule": "nonzero"
      }
    }, [_c('path', {
      attrs: {
        "d": "M14.862 16.397a.802.802 0 01-.36-.086l-2.67-1.342-2.669 1.342a.803.803 0 01-.814-.056.725.725 0 01-.308-.724l.51-2.846-2.16-2.01a.718.718 0 01-.195-.76.766.766 0 01.624-.503l2.985-.415 1.333-2.585A.772.772 0 0111.83 6c.294 0 .563.16.692.412L13.857 9l2.983.415a.766.766 0 01.628.5.718.718 0 01-.191.76l-2.16 2.014.51 2.846a.72.72 0 01-.17.601.79.79 0 01-.59.265l-.005-.003z"
      }
    }), _c('path', {
      attrs: {
        "d": "M7.053 10.185l2.099 1.957a.72.72 0 01.222.655l-.496 2.76 2.595-1.304a.802.802 0 01.72 0l2.593 1.304-.495-2.763a.722.722 0 01.222-.655l2.099-1.954-2.9-.403a.773.773 0 01-.582-.405l-1.298-2.515-1.297 2.515a.772.772 0 01-.582.405l-2.9.403z"
      }
    })])])]));
  }
};